import { savedAdvertisementsService } from '@/api/services/advertisements/advertisementsService'
import BigContainer from '@/components/layout/containers/BigContainer'
import PageWrap from '@/components/layout/containers/PageWrap'
import Footer from '@/components/layout/footer/Footer'
import Header from '@/components/layout/header/Header'
import { Seo } from '@/components/specific/seo/Seo'
import { Pagination } from '@/components/ui/common/pagination'
import { useQuery } from '@tanstack/react-query'
import { useState } from 'react'
import AdsList from './_components/AdsList'

function GraphicsList() {
  const [page, setPage] = useState(1)

  const { data } = useQuery({
    queryKey: ['saved', page],
    queryFn: () => savedAdvertisementsService(page),
    select: (data) => {
      if (data.success) {
        return data.data
      }
      return undefined
    }
  })

  return (
    <>
      <Seo title="Zapisane grafiki | ShopAdverts" />
      <Header />
      <PageWrap className="justify-normal px-2 pt-28 md:px-0">
        <BigContainer>
          <AdsList data={data} />
          <div className="mt-6">
            {data?.items ? (
              <Pagination
                currentPage={page}
                itemsPerPage={12}
                onPageChange={setPage}
                total={data?.total}
              />
            ) : null}
          </div>
        </BigContainer>
      </PageWrap>

      <Footer />
    </>
  )
}

export default GraphicsList
